import styled from "styled-components";

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0 0 0;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const HighlightCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  padding: 0 32px;
  flex-shrink: 0;
`;

export const HighlightCardColumn = styled.div`
  flex: 1;
  display: flex;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  padding: 0 32px;
  flex-shrink: 0;
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & > div:first-child {
    width: auto;
  }
`;

export const FiltersRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  min-width: 150px;
`;

export const AvatarNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const NameCell = styled.span`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const GroupsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`;

